<template>
  <div
    class="withdraw-list mar-top3"
    v-infinite-scroll="loadMore"
    infinite-scroll-disabled="scrollDisabled"
    infinite-scroll-immediate-check="false"
  >
    <div class="title-bottom">
      <span>提现明细</span>
      <span class="select-btn" @click="listDropSelect">{{ dropTile }}</span>
    </div>
    <div class="w-list" v-for="(item, index) in infoList" :key="index">
      <div class="w-list-left">
        <div class="w-list-date">
          <p class="fs_15">{{ item.CreateTime | formatWeekDay }}</p>
          <p class="fs_14">{{ item.CreateTime | fromatTime }}</p>
        </div>
        <div
          class="logo"
          :class="iconfontNameFilter(item.WithdrawDetailType).tempBgClass"
        >
          <span
            :class="[
              'iconfont',
              iconfontNameFilter(item.WithdrawDetailType).tempIcon,
            ]"
          ></span>
        </div>
      </div>
      <div class="w-list-right">
        <div class="subTop">
          <div class="w-list-data">
            <div class="top">
              <div class="t_222 t_left">{{ item.Amount | formatFloat }}</div>
              <div class="errorTag" v-if="item.TransferAccountsStatus === 2">转账失败</div>
            </div>
            <p class="fs_15">
              {{ item.WithdrawDetailType | formatWithdrawDetailType }}
            </p>
          </div>
          <div class="checkReasonType" v-if="item.TransferAccountsStatus !== 2">
            {{ item.TransferAccountsStatus | formatStatus }}
          </div>
          <div
            class="checkReason checkReasonType tapActive"
            v-else
            @click="$emit('checkReason', item.FailRemark)"
          >
            查看原因
          </div>
        </div>
        <div class="subBottom" v-if="item.WithdrawDetailType === 2">
          <div class="subItem">
            <div class="label">提现手续费</div>
            <div class="con">￥{{ item.Poundage.toFixed(2) }}</div>
          </div>
          <div class="subItem">
            <div class="label">实际到账金额</div>
            <div class="con">￥{{ item.AmountToBuyer.toFixed(2) }}</div>
          </div>
          <div class="subItem" v-if="item.TransferAccountsStatus === 0">
            <div class="label">预计到账时间</div>
            <div class="con">{{ item.EstimatedArrivalTime | fromatTime("MM-DD HH:mm:ss") }}</div>
          </div>
          <div class="subItem" v-if="item.TransferAccountsStatus === 1">
            <div class="label">预计到账时间</div>
            <div class="con">{{ item.EstimatedArrivalTime | fromatTime("MM-DD HH:mm:ss") }}</div>
          </div>
          <div class="subItem" v-if="item.TransferAccountsStatus === 2">
            <div class="label">提现失败时间</div>
            <div class="con">{{ item.ActualOperateTime | fromatTime("MM-DD HH:mm:ss") }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Utils from "@/utils/base";

export default {
  props: {
    dropTile: {
      type: String,
      default: "全部",
    },
    infoList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    iconfontNameFilter() {
      return (val) => {
        let tempObj = {};
        switch (val) {
          case 1:
            tempObj.tempBgClass = "";
            tempObj.tempIcon = "icon-weixin1";
            break;
          case 2:
            tempObj.tempBgClass = "card";
            tempObj.tempIcon = "icon-icon";
            break;
          default:
            tempObj.tempBgClass = "zfb";
            tempObj.tempIcon = "icon-zhifubao1";
            break;
        }
        return tempObj;
      };
    },
  },
  methods: {
    loadMore() {
      this.$emit("loadMore");
    },
    listDropSelect() {
      this.$emit("listDropSelect");
    },
  },
  filters: {
    formatWeekDay(val) {
      let isRight = Utils.isYesOrToday(val);
      if (isRight === false) {
        switch (moment(val).days()) {
          case 0:
            return "周日";
          case 1:
            return "周一";
          case 2:
            return "周二";
          case 3:
            return "周三";
          case 4:
            return "周四";
          case 5:
            return "周五";
          case 6:
            return "周六";
        }
      } else {
        return isRight;
      }
    },
    fromatTime(val, rules="MM-DD") {
      return moment(val).format(rules);
    },
    formatFloat(val) {
      if (val) {
        return Number(val).toFixed(2);
      } else {
        return "0.00";
      }
    },
    formatStatus(val) {
      switch (val) {
        case 0:
          return "转账中";
        case 1:
          return "转账成功";
        case 2:
          return "转账失败";
      }
    },
    formatWithdrawDetailType(val) {
      let tempStr = "";
      switch (val) {
        case 1:
          tempStr = "微信";
          break;
        case 2:
          tempStr = "银行卡";
          break;
        default:
          tempStr = "支付宝";
          break;
      }
      return tempStr + "提现";
    },
  },
};
</script>

<style scoped lang="scss">
.withdraw-list {
  background: #fff;
}
.title-bottom {
  border-bottom: 1px solid #eee;
  padding: 3% 4%;
  font-size: 15px;
  color: #999;
}
.title-bottom .select-btn {
  position: relative;
  height: 24px;
  line-height: 21px;
  padding: 0 24px 0 10px;
  box-sizing: border-box;
  display: inline-block;
  margin-left: 10px;
  border: 1px solid #bbbbbb;
  border-radius: 15px;
  font-size: 13px;
  color: #353434;
  cursor: pointer;
}
.select-btn::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-10%);
  width: 0;
  height: 0;
  border: 4px solid transparent;
  border-top-color: #686868;
}
.w-list {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  min-height: 5em;
  padding: 0 5% 0 3%;
  border-bottom: 1px solid #eee;
}
.w-list:last-child {
  border-bottom: none;
}
.w-list-left {
  display: flex;
  color: #999;
  align-items: center;
  height: 5em;
  .logo {
    display: flex;
    align-items: center;
    justify-content: space-around;
    border-radius: 50%;
    width: 38px;
    height: 38px;
    font-size: 36px;
    margin: 0px 10px 0 10px;
    background-color: #259b24;
    color: #fff;
    &.zfb {
      background-color: rgb(74, 134, 246);
    }
    &.card {
      background-color: rgb(69, 126, 232);
    }
    .iconfont {
      font-size: 18px;
    }
  }
}
.w-list-right {
  display: flex;
  flex-direction: column;
  flex: 1;
  color: #999;
  .subTop {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 5em;
    align-items: center;
    padding: 0 1%;
    box-sizing: border-box;
  }
  .subBottom {
    width: 100%;
    border-top: 1px solid #eee;
    padding: 10px 1%;
    box-sizing: border-box;
    font-size: 12px;
    .subItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 5px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.w-list-date {
  width: 50px;
  flex-shrink: 0;
  text-align: center;
}
.w-list-data {
  .top {
    display: flex;
    align-items: center;
    .errorTag {
      background-color: #efefef;
      color: #9a9a9a;
      font-size: 12px;
      padding: 0 4px;
      margin-left: 6px;
    }
  }
}
.fs_14 {
  font-size: 14px;
}
.fs_15 {
  font-size: 15px;
}
.fs_18 {
  font-size: 18px;
}
.t_222 {
  color: #222;
}
.t_left {
  text-align: left !important;
  font-size: 16px;
}

.checkReasonType {
  width: 62px;
  text-align: right;
  color: #000;
}

.checkReason {
  position: relative;
  right: -3px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 28px;
  border-radius: 14px;
  color: #ff1a2c;
  border: 1px solid #ff1a2c;
  font-size: 12px;
  box-sizing: border-box;
}
</style>
